import React from "react";
import "./landing.css";

const FACTS = [
  { label: "Delivery zone", value: "Kalamoun to Menniye" },
  { label: "Payment", value: "Cash on delivery" },
  { label: "Order by", value: "App, email or phone" },
];

export default function Hero() {
  const scrollToOrdering = (e) => {
    e.preventDefault();
    const section = document.getElementById("ordering");
    if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="tfm-hero" id="home">
      <div className="tfm-container tfm-hero__inner">
        <div className="tfm-hero__copy">
          <p className="tfm-eyebrow">Tripoli Municipal Fresh Market</p>

          <h1 className="tfm-hero__title">
            The market floor,
            <br />
            <em>on your phone.</em>
          </h1>

          <p className="tfm-hero__lede">
            Wholesale fruit and vegetables for the restaurants, hotels and shops
            of greater Tripoli. Prices are set every morning on the market
            floor — see what is available, send your order, and we deliver at
            the time that suits your kitchen.
          </p>

          <div className="tfm-hero__actions">
            <a
              className="tfm-btn tfm-btn--sun"
              href="#ordering"
              onClick={scrollToOrdering}
            >
              Start an order
              <ArrowIcon />
            </a>
            <a className="tfm-btn tfm-btn--ghost" href="tel:+96171144332">
              <PhoneIcon />
              +961 71 144 332
            </a>
          </div>

          <dl className="tfm-hero__facts">
            {FACTS.map((fact) => (
              <div key={fact.label}>
                <dt className="tfm-mono">{fact.label}</dt>
                <dd>{fact.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="tfm-hero__media">
          <span className="tfm-hero__disc" aria-hidden="true" />
          <img
            className="tfm-hero__phone"
            src="/images/hero-app.png"
            alt="The Tripoli Fresh Market app open on the produce categories screen"
            width="900"
            height="1023"
          />
        </div>
      </div>
    </section>
  );
}

function ArrowIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M5 12h14m-6-6 6 6-6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.707 12.293a.999.999 0 00-1.414 0l-1.594 1.594c-.739-.22-2.118-.72-2.992-1.594s-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 000-1.414l-4-4a.999.999 0 00-1.414 0L3.581 5.005c-.38.38-.594.902-.586 1.435.023 1.424.4 6.37 4.298 10.268s8.844 4.274 10.269 4.298h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 000-1.414l-4-4.001z" />
    </svg>
  );
}
